import { MimaButton, MimaDropdown, ReceiptCheckBox as RCB, MimaText, Modal } from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import successImg from '../../assets/img/Successful.png';
import { employeeStore, userStore } from '../../stores';
import { Formik } from 'formik';

import React from 'react';

const AddBulkEmployees = ({
	closeModal,
	uploaded,
	validationSchema,
	uploadClick,
	file,
	selectClick,
	loading,
	needFeedback,
	setShowSurvey,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitle" mb={3}>
				Add Bulk Employees
			</MimaText>
			{!uploaded && (
				<>
					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						To add your Employees in bulk kindly click the button below and
						download our excel template.
					</MimaText>

					<a
						href="https://res.cloudinary.com/mima-business/raw/upload/v1692697552/Employee-Bulk-test_ur5fvs_f1o0fk_2_gyrhwi.xlsx"
						target="_blank"
						rel="noreferrer">
						<MimaButton
							title="Download Template"
							variant="colorable"
							buttonColor="var(--color-dark)"
							mb={5}
						/>
					</a>

					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						Fill the downloaded template with your employee information and then
						upload in the next button
					</MimaText>
					<Formik
						initialValues={{
							department: '',
							departmentName: '',
							employeeGroupName: '',
							employeeGroup: '',
							settlementCycle: 'MONTHLY'
						}}
						validationSchema={validationSchema}
						onSubmit={uploadClick}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<>
								<MimaButton
									title="Select file"
									variant="outlined"
									width={38}
									onClick={selectClick}
								/>
								<MimaText
									variant="small"
									mt={2}
									width={38}
									align="center"
									color="var(--color-primary)">
									{file?.name || ''}{' '}
								</MimaText>
								<MimaText ml={2} mb={0.5} mt={2} variant="small" width={38}>
									Payment Cycle
								</MimaText>

								<div className={styles.checks}>
									<RCB
										title="WEEKLY"
										id="WEEKLY"
										name="settlementCycle"
										onChange={() => {
											setFieldValue('settlementCycle', 'WEEKLY');
										}}
										checked={values.settlementCycle === 'WEEKLY'}
										value="WEEKLY"
									/>
									<RCB
										title="BI-WEEKLY"
										id="BI-WEEKLY"
										name="settlementCycle"
										onChange={() => {
											setFieldValue('settlementCycle', 'BI-WEEKLY');
										}}
										checked={values.settlementCycle === 'BI-WEEKLY'}
										value="BI-WEEKLY"
									/>
									<RCB
										title="MONTHLY"
										id="MONTHLY"
										name="settlementCycle"
										onChange={() => {
											setFieldValue('settlementCycle', 'MONTHLY');
										}}
										checked={values.settlementCycle === 'MONTHLY'}
										value="MONTHLY"
									/>
								</div>

								{errors.settlementCycle ? (
									<div className={styles.error}>
										{''}
										{touched.settlementCycle && errors.settlementCycle}
										{''}
									</div>
								) : null}

								<MimaDropdown
									labelTitle="Department(optional)"
									placeholder="Select"
									canSelectAll={true}
									name="department"
									value={values.departmentName}
									id="department"
									onChange={data => {
										setFieldValue('department', data.key);
										setFieldValue('departmentName', data.value);
									}}
									data={employeeStore.mapDepartments}
									touched={touched.department}
								/>
								{/* <MimaDropdown
									labelTitle="Group(optional)"
									placeholder="Select"
									canSelectAll={true}
									name="employeeGroup"
									currentValue={values.employeeGroupName}
									value={values.employeeGroup}
									id="employeeGroup"
									onChange={data => {
										setFieldValue('employeeGroup', data.key);
										setFieldValue('employeeGroupName', data.value);
									}}
									data={employeeStore.mapGroups}
									touched={touched.employeeGroup}
								/> */}

								<MimaButton
									disabled={loading}
									loading={loading}
									title="Upload Employees Info"
									type="submit"
									onClick={handleSubmit}
								/>
							</>
						)}
					</Formik>
				</>
			)}
			{uploaded && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}>
						Upload <br />
						Successful
					</MimaText>
					{/* <MimaText width={38} align="center" color="var(--color-primary)">
						You successfully uploaded 35 employees
					</MimaText> */}
					<MimaButton title="Continue" onClick={() => {
						closeModal();
						if (needFeedback._id) {
							setShowSurvey(true)
							userStore.setReviewId(needFeedback._id)
						}
						return;
					}} mt={3} />
				</>
			)}
		</Modal>
	);
};

export default AddBulkEmployees;
